import React from "react";

const InteractionIcon = ({width=15,height=15}) => {
  return (
    <svg width={width} height={height} cursor="pointer" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.125 5.625H16.875M3.125 10H10M3.125 14.375H16.875" stroke="#5C91FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  );
};

export default InteractionIcon;
